import React, { useEffect, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Button,
  Paper,
  Grid,
  Chip,
  CircularProgress,
  Typography,
} from "@mui/material";
import { Input, notification, Table } from "antd";
import { SearchIcn } from "../../Svg/icons";
import {
  useGetInvitedEventsMutation,
  useInviteEventMutation,
} from "../../Redux/apis/ApiSlice";
import { useNavigate, useLocation } from "react-router-dom";
import { useAcceptInvitationMutation } from "../../Redux/apis/ApiSlice";
import { useDeclineInvitationMutation } from "../../Redux/apis/ApiSlice";
import useMediaQuery from "@mui/material/useMediaQuery";
import InviteCard from "../../components/InvitationCard/InviteCard";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import AddYourEventButton from "../../components/HomeLandingPage/Search/AddYourEventButton";

function EventInvites() {
  const [acceptInvitation] = useAcceptInvitationMutation();
  const [declineInvitation] = useDeclineInvitationMutation();
  const [inviteEvent, { isLoading }] = useInviteEventMutation();
  const [getInvitedEvents, { data, isSuccess }] = useGetInvitedEventsMutation();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(3);
  const [totalPages, setTotalPages] = useState(0);
  const [value, setValue] = useState(0);
  const [inviteData, setInviteData] = useState([]);
  const [send, setSend] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchReceived, setSearchReceived] = useState("");
  const [searchSent, setSearchSent] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [currentEventId, setCurrentEventId] = useState(null);
  const [role, setRole] = useState(null);
  const [event, setEventInfo] = useState(null);
  const userEmail = userData?.email;
  const userName = userData?.name;
  const [eventId, setEventId] = useState("");
  const [eventInviteType, setEventInviteType] = useState("");
  const [userId, setUserId] = useState("");
  const payload = {
    email: userEmail,
    isSend: false,
    searchKey: searchText,
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchInvitedEvents(send, newPage, pageSize);
  };

  const handleAccept = async (invitationId, eventId, invitation) => {
    try {
      const response = await acceptInvitation({
        invitationId,
        eventId,
      }).unwrap();

      const fullEventDetails = invitation.event; // Access the event details
      if (!fullEventDetails) {
        console.log("fullEventDetails is undefined");
      } else {
        console.log("fullEventDetails:", fullEventDetails); // Log event details if they exist
      }

      if (invitation.roleId === 3) {
        navigate(`/event-detailDesc/${invitation.eventId}`, {
          state: { event: fullEventDetails },
        });
      } else if (invitation.roleId === 2) {
        navigate(`/eventmanagement`);
      } else {
        console.log("User's role is not 3, skipping navigation");
      }

      notification.success({
        message: "Invitation accepted successfully!",
      });

      await fetchInvitedEvents(send);
    } catch (error) {
      console.error("Error accepting invitation:", error);
    }
  };

  const handleDecline = async (invitationId) => {
    try {
      const response = await declineInvitation({ invitationId }).unwrap();
      notification.success({
        message: "Invitation declined successfully!",
      });
      // Optionally, refetch or update the local state after acceptance
      await fetchInvitedEvents(send);
    } catch (error) {
      console.error("Failed to decline invitation:", error);
      alert(error.message); // Show error message to the user
    }
  };

  const handleChange = async (event, newValue) => {
    setValue(newValue);
    const isSendValue = newValue === 1;
    setSend(isSendValue);

    await fetchInvitedEvents(isSendValue);
  };
  const [loading, setLoading] = useState(false);

  const fetchInvitedEvents = async (isSendValue, page = 1, pageSize = 3) => {
    setLoading(true);
    try {
      const response = await getInvitedEvents({
        email: userEmail,
        isSend: isSendValue,
        searchKey: isSendValue ? searchSent : searchReceived,
        page,
        limit: pageSize,
      }).unwrap();
      const eventData = mapInviteData(response.invitations, isSendValue);
      console.log("eventData", eventData);
      setInviteData(eventData);
      setCurrentPage(page);
      setTotalPages(Math.ceil(response.count / pageSize));
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvitedEvents(send, 1, pageSize);
  }, [send, searchReceived, searchSent]);

  // Ensure inviteData is an array before mapping
  const events = Array.isArray(inviteData)
    ? inviteData.map((invite) => ({
        organizationName: invite.organizationName || "",
        eventId: invite.eventId || "",
        eventName: invite.eventName || "",
        location: invite.location || "",
        status: invite.status || "",
        invitationId: invite.invitationId || "",
        roleId: invite.roleId || "",
        event: invite.event || null,
      }))
    : [];

  const mapInviteData = (response, isSendValue) => {
    return response.map((invitation) => {
      // Log invitation to ensure event is properly present
      if (invitation.roleId === 3) {
        setCurrentEventId(invitation.event.eventId);
        setEventInfo(invitation.event);
      }

      // Return the mapped invitation data
      return {
        // organizationName: invitation.event?.organizationName || "",
        // organizationName: invitation.event?.eventOrganizers[0]?.user?.fullName || "",
        organizationName: isSendValue
          ? userName || ""
          : invitation.event?.eventOrganizers[0]?.user?.fullName || "",
        eventId: invitation.event?.eventId || "",
        eventName: invitation.event?.eventName || "",
        location: invitation.event?.location || "",
        status: invitation.status || "",
        invitationId: invitation.invitationId || "",
        roleId: invitation.roleId || "",
        event: invitation.event || null, // Check if event is actually being set
      };
    });
  };

  function extractValues() {
    const queryString = location.search; // Get the query parameters part of the URL
    const urlParams = new URLSearchParams(queryString);

    // Extract values from URL parameters
    const eventId = urlParams.get("eventId");
    const inviteType = urlParams.get("eventInviteType");
    const userId = urlParams.get("user");

    // Decode Base64 values
    function decryptParam(param) {
      return param ? atob(param) : null; // Decode only if param exists
    }

    const eventIdDec = decryptParam(eventId);
    const eventInviteTypeDec = decryptParam(inviteType);
    const userIdDec = decryptParam(userId);

    // Set states if using React (optional)
    if (typeof setEventId === "function") setEventId(eventIdDec);
    if (typeof setEventInviteType === "function")
      setEventInviteType(eventInviteTypeDec);
    if (typeof setUserId === "function") setUserId(userIdDec);

    getInvitedEvents();
    return { eventIdDec, eventInviteTypeDec, userIdDec };
  }

  useEffect(() => {
    const { eventIdDec, eventInviteTypeDec, userIdDec } = extractValues();
    if (eventIdDec && eventInviteTypeDec && userIdDec) {
      // Send API request to invite user
      inviteEvent({
        eventId: eventIdDec,
        eventInviteType: eventInviteTypeDec,
        sentBy: userIdDec,
        email: userEmail,
      })
        .then((response) => {
          navigate("/eventinvites", { replace: true });
          if ("data" in response) {
            fetchInvitedEvents(send);
          } else if ("error" in response) {
            console.error("Invitation Failed:", response.error);
          }
        })
        .catch((err) => console.error("API Error:", err));
    }
  }, []);

  const renderStatusChip = (status) => {
    let color;
    let label;
    let backgroundColor;

    switch (status) {
      case "upcoming" || "Upcoming":
        color = "purple";
        backgroundColor = "rgba(128, 0, 128, 0.1)";
        label = "Upcoming";
        break;
      case "declined":
        color = "red";
        backgroundColor = "rgba(250, 0, 0, 0.1)";
        label = "declined";
        break;
      case "pending" || "Pending":
        color = "rgb(6,31,68)";
        backgroundColor = "rgba(128, 128, 128, 0.1)";
        label = "Pending";
        break;
      case "accepted":
        color = "green";
        backgroundColor = "rgba(0, 128, 0, 0.1)";
        label = "accepted";
        break;
      default:
        color = "grey";
        backgroundColor = "rgba(128, 128, 128, 0.1)"; // 70% transparent grey
        label = "Unknown";
    }

    return (
      <Chip
        icon={
          <svg
            width="5"
            height="6"
            viewBox="0 0 5 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="2.5" cy="3" r="2.5" fill={color} />
          </svg>
        }
        size="small"
        label={label}
        style={{
          color: color,
          backgroundColor: backgroundColor,
          fontWeight: 500,
          fontSize: "12px",
          height: "22px",
          justifyContent: "left",
          gap: 2,
          padding: 2,
        }}
      />
    );
  };

  const getColumns = (value) => {
    const columns = [
      {
        dataIndex: "organizationName",
        title: (
          <span style={{ width: "70px", textAlign: "center" }}>Organizer</span>
        ),
        key: "organizationName",
        render: (text) => (
          <span style={{ width: "100%", textAlign: "center" }}>{text}</span>
        ),
      },
      {
        dataIndex: "eventName",
        title: "Event Name",
        key: "eventName",
        render: (text) => text,
      },
      {
        dataIndex: "location",
        title: "Location",
        key: "location",
        render: (text) => <p>{text}</p>,
      },
      {
        dataIndex: "status",
        title: "Status",
        key: "status",
        render: (text, record) => (
          <div
            style={{
              width: "100px",
              whiteSpace: "nowrap",
              textAlign: "center",
            }}
          >
            {renderStatusChip(text)}
          </div>
        ),
      },
    ];

    // Add the "Action" column only if value === 0
    if (value === 0) {
      columns.push({
        dataIndex: "action",
        title: "Action",
        key: "action",
        render: (text, record) => {
          if (record.status === "declined" || record.status === "accepted")
            return <div style={{ width: "50px" }}>-</div>;
          return (
            <div style={{ width: "100%", whiteSpace: "nowrap", gap: 3 }}>
              <Button
                sx={{
                  backgroundColor: "#FAFBFB",
                  color: "red",
                  borderRadius: 5,
                  fontSize: "12px",

                  fontWeight: 500,
                }}
                onClick={() => handleDecline(record.invitationId)}
              >
                Decline
              </Button>
              <Button
                sx={{
                  backgroundColor: "#FAFBFB",
                  color: "#2E728F",
                  borderRadius: 5,
                  fontSize: "12px",

                  fontWeight: 500,
                }}
                onClick={() =>
                  handleAccept(record.invitationId, record.eventId, record)
                }
              >
                Accept
              </Button>
            </div>
          );
        },
      });
    }

    return columns;
  };

  const handleSearchChange = (event, isSendValue) => {
    const searchValue = event.target.value;
    if (isSendValue) {
      setSearchSent(searchValue);
    } else {
      setSearchReceived(searchValue);
    }
  };

  return (
    <Grid sx={{ p: { md: 1.5, xs: 0 } }}>
      {/* <AddYourEventButton/> */}
      {isLoading && <p>Sending invite...</p>}
      <Paper
        elevation={1}
        sx={{
          height: { md: "87vh", sm: "90%", xs: "90%" },
          padding: 2,
          overflowX: "hidden",
          maxWidth: "100%",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ maxWidth: "100%" }}
        >
          <Tab label="Received" />
          <Tab label="Sent" />
        </Tabs>
        {value === 0 && (
          <Box sx={{ mt: 3, p: { md: 2, xs: 0 } }}>
            <Input
              style={{
                width: "100%",
                maxWidth: 400,
                marginBottom: 16,
              }}
              prefix={<SearchIcn />}
              placeholder="Search by Event Name OR Organization Name"
              size="large"
              onChange={(event) => handleSearchChange(event, value === 1)}
            />

            <Box>
              {loading ? (
                <>Loading...</>
              ) : (
                <>
                  {events.length > 0 ? (
                    <>
                      {isMobile ? (
                        <div className="px-4">
                          {events.map((invite) => (
                            <InviteCard
                              key={invite.invitationId}
                              invite={invite}
                              sent={false}
                              onAccept={handleAccept}
                              onDecline={handleDecline}
                            />
                          ))}
                          <Box
                            sx={{
                              mt: 4,
                              // mx: 2,
                              px: 2,
                              py: 2,
                              borderRadius: 3,
                              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                              backgroundColor: "rgba(255, 255, 255, 0.85)",
                              backdropFilter: "blur(8px)",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              position: "sticky",
                              bottom: 16,
                              zIndex: 10,
                            }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                              sx={{
                                textTransform: "none",
                                borderRadius: "999px",
                                px: 2,
                                py: 1,
                                backgroundColor:
                                  currentPage === 1 ? "#e0e0e0" : "#1976d2",
                                color: currentPage === 1 ? "#9e9e9e" : "#fff",
                                "&:hover": {
                                  backgroundColor:
                                    currentPage === 1 ? "#e0e0e0" : "#115293",
                                },
                              }}
                            >
                              Previous
                            </Button>

                            <Typography
                              variant="body2"
                              sx={{ color: "#555", fontWeight: 500 }}
                            >
                              Page {currentPage} of {totalPages}
                            </Typography>

                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => {
                                if (currentPage < totalPages)
                                  handlePageChange(currentPage + 1);
                              }}
                              disabled={currentPage === totalPages}
                              sx={{
                                textTransform: "none",
                                borderRadius: "999px",
                                px: 3,
                                py: 1,
                                backgroundColor:
                                  currentPage === totalPages
                                    ? "#e0e0e0"
                                    : "#1976d2",
                                color:
                                  currentPage === totalPages
                                    ? "#9e9e9e"
                                    : "#fff",
                                "&:hover": {
                                  backgroundColor:
                                    currentPage === totalPages
                                      ? "#e0e0e0"
                                      : "#115293",
                                },
                              }}
                            >
                              Next
                            </Button>
                          </Box>
                        </div>
                      ) : (
                        <Table
                          style={{
                            border: "none",
                            minWidth: "100%",
                            overflow: "auto",
                            maxHeight: 430,
                          }}
                          rowClassName={() => "custom-row"}
                          columns={getColumns(0)} // Use the dynamically generated columns
                          dataSource={events}
                          pagination={{
                            current: currentPage,
                            pageSize: pageSize,
                            onChange: (page) =>
                              fetchInvitedEvents(send, page, pageSize),
                            total: totalPages * pageSize, // or use `response.totalCount` if returned directly
                          }}
                        />
                      )}
                    </>
                  ) : (
                    <p>No invitations found</p>
                  )}
                </>
              )}
            </Box>
          </Box>
        )}
        {value === 1 && (
          <Box sx={{ mt: 3, p: 2 }}>
            <Input
              prefix={<SearchIcn />}
              placeholder="Search by Event Name OR Organization Name"
              size="large"
              onChange={(event) => {
                setSearchSent(event.target.value); // Update searchSent state
              }}
              style={{
                width: "100%",
                maxWidth: 400,
                marginBottom: 16,
              }}
            />

            <Box>
              {loading ? (
                <>Loading...</>
              ) : events.length > 0 ? (
                <>
                  {isMobile ? (
                    <div className="px-4">
                      {events.map((invite) => (
                        <InviteCard
                          key={invite.invitationId}
                          invite={invite}
                          sent={true}
                        />
                      ))}
                      <Box
                        sx={{
                          mt: 4,
                          // mx: 2,
                          px: 1,
                          py: 2,
                          borderRadius: 3,
                          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                          backgroundColor: "rgba(255, 255, 255, 0.85)",
                          backdropFilter: "blur(8px)",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          position: "sticky",
                          bottom: 16,
                          zIndex: 10,
                        }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                          sx={{
                            textTransform: "none",
                            borderRadius: "999px",
                            px: 1,
                            py: 1,
                            backgroundColor:
                              currentPage === 1 ? "#e0e0e0" : "#1976d2",
                            color: currentPage === 1 ? "#9e9e9e" : "#fff",
                            "&:hover": {
                              backgroundColor:
                                currentPage === 1 ? "#e0e0e0" : "#115293",
                            },
                          }}
                        >
                          Previous
                        </Button>

                        <Typography
                          variant="body2"
                          sx={{ color: "#555", fontWeight: 500 }}
                        >
                          Page {currentPage} of {totalPages}
                        </Typography>

                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => {
                            if (currentPage < totalPages)
                              handlePageChange(currentPage + 1);
                          }}
                          disabled={currentPage === totalPages}
                          sx={{
                            textTransform: "none",
                            borderRadius: "999px",
                            px: 2,
                            py: 1,
                            backgroundColor:
                              currentPage === totalPages
                                ? "#e0e0e0"
                                : "#1976d2",
                            color:
                              currentPage === totalPages ? "#9e9e9e" : "#fff",
                            "&:hover": {
                              backgroundColor:
                                currentPage === totalPages
                                  ? "#e0e0e0"
                                  : "#115293",
                            },
                          }}
                        >
                          Next
                        </Button>
                      </Box>
                    </div>
                  ) : (
                    <Table
                      style={{
                        border: "none",
                        minWidth: "100%",
                        overflow: "auto",
                        maxHeight: 430,
                      }}
                      rowClassName={() => "custom-row"}
                      columns={getColumns(1)}
                      dataSource={events}
                      pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        onChange: (page) =>
                          fetchInvitedEvents(send, page, pageSize),
                        total: totalPages * pageSize, // or use `response.totalCount` if returned directly
                      }}
                    />
                  )}
                </>
              ) : (
                <p>No invitations sent</p>
              )}
            </Box>
          </Box>
        )}
      </Paper>
    </Grid>
  );
}

export default EventInvites;
